import { render, staticRenderFns } from "./settle-dialog.vue?vue&type=template&id=15450c1d&scoped=true"
import script from "./settle-dialog.vue?vue&type=script&lang=js"
export * from "./settle-dialog.vue?vue&type=script&lang=js"
import style0 from "./settle-dialog.vue?vue&type=style&index=0&id=15450c1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15450c1d",
  null
  
)

export default component.exports